import type { FireIconProps } from './types';

export default function ExitSign({ size = 24, color = 'currentColor', strokeWidth = 2, className, ...props }: FireIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
      className={className} {...props}>
      {/* Sign box */}
      <rect x="2" y="5" width="20" height="14" rx="1" />
      {/* Running person */}
      <circle cx="10" cy="9" r="1.5" />
      <path d="M10 10.5l-2 4" />
      <path d="M10 10.5l2 4" />
      <path d="M8 12.5l-2 1" />
      <path d="M12 12.5l2-1" />
      {/* Arrow */}
      <line x1="16" y1="12" x2="20" y2="12" />
      <polyline points="18 10 20 12 18 14" />
    </svg>
  );
}
